import { FindMyAccountAlertProps, FindMyAccountFields } from '../../components/SmartErrorAlert';
import translate from '../translate';
import {
    forgotUsernameErrFns,
    ForgotUsernameErrState
} from './forgotUsernameErrors';
import { ErrorContentGenerator } from './getAlertContent';

export const findMyAccountErrFns = new ErrorContentGenerator<FindMyAccountAlertProps, FindMyAccountFields, ForgotUsernameErrState>({
    apiErrorContent: {
        ...forgotUsernameErrFns.apiErrorContent,
        unknown: {
            header: translate("we_cant_find_account_at_this_time"),
            body: forgotUsernameErrFns.apiErrorContent.unknown.body,
            analyticsErr: "We can't find your account at this time. Check the information you entered and try again, or call 1-800-MEDICARE (1-800-633-4227). TTY users can call 1-877-486-2048."
        }
    },
    invalidFieldMessages: forgotUsernameErrFns.invalidFieldMessages,
    invalidFieldHeader: 'complete_items_to_find_account',
    getRefMap: props => {
        return {
            mbi: props.mbiRef,
            lastName: props.lastNameRef,
            dateOfBirth: props.dateOfBirthRef
        }
    },
    getErrState: forgotUsernameErrFns.getErrState,
    getApiInvalidFields: forgotUsernameErrFns.getApiInvalidFields,
    isIntermediateStep: false
});